import React from 'react'
import styled from 'styled-components'
import { IconCheck } from '../../../../'

interface CheckboxProps {
  isChecked?: boolean
  label?: any
  onChange: (_: string) => void
  name?: string
  value?: string | number
  size?: Sizes
  children?: React.ReactNode | any
}

export const Checkbox = ({
  isChecked,

  onChange,
  name,
  value,
  children,
  size = 'normal',
}: CheckboxProps) => {
  return (
    <Container size={size}>
      <Label tabIndex="0" onClick={() => onChange(value as string)} size={size}>
        <Input type="checkbox" name={name} />
        <Span size={size} isChecked={isChecked}>
          {isChecked && <IconCheck />}
        </Span>
        {children}
      </Label>
    </Container>
  )
}

type Sizes = 'normal' | 'small' | 'tiny'

type StyledProps = {
  size?: Sizes
  isChecked?: boolean
}

const Container = styled.div<StyledProps>`
  // word-break: break-all;
  box-sizing: border-box;
  user-select: none;
`

const Label = styled.div.attrs({
  className: 'my-2',
})<any>`
  display: inline-flex;
  align-items: start;
  font-size: ${({ size }) => {
    if (size === 'tiny') {
      return '1.4rem'
    }

    if (size === 'small') {
      return '1.5rem'
    }

    return '1.6rem'
  }};
  cursor: pointer;
  position: relative;
  height: 100%;
  color: ${({ theme }) => theme.palette.primary};

  @media (min-width: ${({ theme }) => theme.breakpoints.md.min}) {
    &:hover {
      opacity: 0.6;
    }
  }
`

const Input = styled.input`
  display: none;
`

const Span = styled.span.attrs((props: any) => ({
  className: props.size === 'tiny' ? 'mr-2' : 'mr-3',
}))<StyledProps>`
  align-self: baseline;
  margin-top: 0.23rem;
  height: ${({ size }) => {
    if (size === 'tiny') {
      return '1.7rem'
    }

    return '2rem'
  }};
  min-width: ${({ size }) => {
    if (size === 'tiny') {
      return '1.7rem'
    }

    return '2rem'
  }};

  border: 0.1rem solid
    ${(props) => {
      if (props.size === 'tiny' && !props.isChecked) {
        return props.theme.palette.grey
      }

      return props.theme.palette.silverTree
    }};

  background-color: ${(props) =>
    props.theme.palette[props.isChecked ? 'silverTree' : 'secondary']};
  color: ${({ theme }) => theme.palette.secondary};
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  border-radius: ${({ size }) => {
    if (size === 'tiny') {
      return '0.2rem'
    }

    return '0'
  }};

  & svg {
    width: ${({ size }) => {
      if (size === 'tiny') {
        return '1.3rem'
      }

      return '1.6rem'
    }};
  }
`
